import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const LocationModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();

    columns.push({key:'id', width: 80, sorter:true,title:<Trans>#</Trans>});
    columns.push({key:'supplier.code', dataIndex: ['supplier', 'code'], width: 150, sorter:true,title:<Trans>Supplier Code</Trans>});
    columns.push({key:'name', width: 150, sorter:true,title:<Trans>Name</Trans>});
    columns.push({
        key: 'valid',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>Yes</Trans>,
                value: 'true',
            },
            {
                label: <Trans>No</Trans>,
                value: 'false',
            }
        ],
        sorter: true,
        width: 100,
        title: <Trans>Valid</Trans>,
        render: (value: boolean) => (
            <Tag color={value ? 'green' : 'red'}>
                {value ? <Trans>Yes</Trans> : <Trans>No</Trans>}
            </Tag>
        )
    });

    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 200, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/locations"
    };
}
export default LocationModel();
